/* eslint-disable max-len */
import { TableBody, TableHead, TableRow, Icon } from "@mui/material";
import {
  useMemo,
  useState,
  useContext,
  useRef,
  createRef,
  useEffect,
  SetStateAction,
} from "react";
import { useScreenClass } from "react-grid-system";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { UserContext } from "../../context/UserContext";
import theme from "../../styles/theme";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ClickableIcon } from "../../components/Icon";
import TableComponent, {
  StyledBodyCell,
  StyledHeaderCell,
  StyledTableRow,
} from "../../components/Table";
import {
  EmptyPillarNavigation,
  EmptyPillarTypeDetail,
  PillarNavigationType,
  PillarTypeDetail,
} from "../../types/Roadmap";
import PillarSubdomainModify from "../../components/PillarSubdomainModify";
import Button from "../../components/Button";
import axios from "axios";
import { CustomFlex } from "./ModifyPillarDetail";
import PillarNavigator from "../../components/PillarNavigator";
import PillarSubdomainCreate from "../../components/PillarSubdomainCreate";
import KnowledgeAreaCreate from "../../components/KnowledgeAreaCreate";
import KnowledgeTopicCreate from "../../components/KnowledgeTopicCreate";
import SnackBar from "../../components/SnackBar";
import LoadingSpinner from "../../components/LoadingSpinner";
import { VersionContext } from "../../context/VersionContext";
import ConfirmModal from "../../components/ConfirmModal";
import { SaveButton } from "../../components/PillarOverviewModify";
interface Column {
  id: "title" | "description" | "action";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}
function SubdomainKnowledgeTopics() {
  const ref = useRef(null);
  const { pillarId, subdomainId, knowledgeId } = useParams();
  const navigate = useNavigate();
  const [isCreateOpen, setIsCreateOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const { version } = useContext(VersionContext);
  const [currentPillar, setCurrentPillar] = useState<PillarTypeDetail>();
  const [isConfirmOpen, setIsConfirmOpen] = useState<boolean>(false);
  const [isOverride, setIsOverride] = useState<boolean>(false);
  const defaultConfirmMessage =
    "Are you sure you want to delete this knowledge topic?";
  const [confirmMessage, setConfirmMessage] = useState(defaultConfirmMessage);
  const [knowledgeTopic, setKnowledgeTopic] = useState<Array<any>>([]);
  const [knowledgeDetail, setKnowledgeDetail] = useState<{
    id: string;
    description: string;
    title: string;
    knowledge_topics: Array<{
      id: string;
      description: string;
      title: string;
    }>;
  }>({
    id: "",
    description: "",
    title: "",
    knowledge_topics: [],
  });
  const [pillarNavigation, setPillarNavigation] =
    useState<PillarNavigationType>(EmptyPillarNavigation);
  const [columns, setColumns] = useState<Array<Column>>([
    { id: "title", label: "Knowledge Area Title", minWidth: 200 },
    {
      id: "description",
      label: "Description",
      minWidth: 150,
    },
    {
      id: "action",
      label: "",
      minWidth: 155,
    },
  ]);
  useEffect(() => {
    if (pillarId && subdomainId && knowledgeId) {
      // fetchSubdomain(pillarId, subdomainId, knowledgeId)
      fetchTopic(pillarId, subdomainId, knowledgeId);
    }
  }, []);
  const fetchTopic = (
    pillar_id: string,
    subdomain_id: string,
    knowledge_id: string
  ) => {
    setLoading(true);
    axios
      .get(`/knowledgetopic?area_id=${knowledge_id}`)
      .then((res) => {
        axios
          .get(`/pillar?curriculum_version=${version.version_number}`)
          .then((res1) => {
            axios
              .get(`/subdomain/summary?pillar_id=${pillarId}&curriculum_version=${version.version_number}`)
              .then((res2) => {
                axios
                  .get(
                    `/knowledgearea?subdomain_id=${subdomain_id}&area_id=${knowledge_id}`
                  )
                  .then((res3) => {
                    setKnowledgeTopic(res.data.knowledgetopics);
                    setPillarNavigation({
                      ...pillarNavigation,
                      id: pillar_id,
                      title: res1.data.pillars.find(
                        (v: any) => v.id === pillarId
                      ).title,
                      subdomains: {
                        ...pillarNavigation.subdomains,
                        title: res2.data.subdomains.find(
                          (v: any) => v.id === subdomainId
                        ).title,
                        id: subdomain_id,
                        knowledge_areas: {
                          ...pillarNavigation.subdomains.knowledge_areas,
                          id: knowledge_id,
                          title: res3.data.knowledgeareas[0].title,
                          knowledge_topics: {
                            ...pillarNavigation.subdomains.knowledge_areas
                              .knowledge_topics,
                          },
                        },
                      },
                    });
                  })
                  .catch(() => setLoading(false));
              })
              .catch(() => {
                setLoading(false);
              });
          })
          .catch(() => {
            setLoading(false);
          });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const createKnowledge = (data: any) => {
    setLoading(true);
    axios
      .post("/knowledgetopic/new", { ...data, area_id: knowledgeId })
      .then((res) => {
        setMessage("Created knowledge topic successfully");
        setIsSnackbarOpen(true);
        setLoading(false);
        setIsCreateOpen(false);
        fetchTopic(pillarId || "", subdomainId || "", knowledgeId || "");
      })
      .catch(function (error) {
        if (error.response) {
          setMessage(
            error.response.data.error || "Failed to create knowledge topic!"
          );
          setIsErrorOpen(true);
        } else if (error.request) {
          console.log(error.request);
        } else {
          setMessage(error.response.data.error);
          setIsErrorOpen(true);
        }
        setLoading(false);
      });
  };
  const deleteSubdomain = () => {
    axios
      .delete(
        `/knowledgetopic/delete?topic_id=${currentPillar?.id}&curriculum_version=${version.version_number}&override_usage=${isOverride}`
      )
      .then((res) => {
        if (res.data.result.deleted) {
          setMessage("Knowledge topic deleted successfully!");
          setIsSnackbarOpen(true);
          setLoading(false);
          fetchTopic(pillarId || "", subdomainId || "", knowledgeId || "");
          setConfirmMessage(defaultConfirmMessage);
          setIsOverride(false);
          setIsConfirmOpen(false);
        } else {
          // setMessage(res.data.result.message);
          // setIsSnackbarOpen(true);
          setLoading(false);
          setIsConfirmOpen(true);
          setConfirmMessage(res.data.result.message +".\n"+ defaultConfirmMessage);
          setIsOverride(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setMessage(
            error.response.data.error || "Failed to delete knowledge Topic!"
          );
          setIsErrorOpen(true);
        } else if (error.request) {
          console.log(error.request);
        } else {
          setMessage(error.response.data.error);
          setIsErrorOpen(true);
        }
      });
  };
  const handleOpen = (value: boolean) => {
    setIsConfirmOpen(value);
    setIsOverride(false);
    setConfirmMessage(defaultConfirmMessage);
  };
  return (
    <>
      {isCreateOpen && (
        <KnowledgeTopicCreate
          header="Create Knowledge Topic"
          mode="create"
          isOpen={isCreateOpen}
          setOpen={setIsCreateOpen}
          onSaveComplete={(data) => {
            createKnowledge(data);
          }}
        />
      )}
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={message}
        type="error"
      />
      <ConfirmModal
        isOpen={isConfirmOpen}
        setOpen={handleOpen}
        confirmFunction={() => {
          deleteSubdomain();
        }}
        title={"Delete Knowledge Topic"}
        description={confirmMessage}
      />
      {loading && <LoadingSpinner />}
      <CustomFlex
        style={{
          minHeight: "inherit",
          height: "100%",
          borderBottom: "none",
          alignItems: "flex-start",
          overflowY: "scroll",
          padding: 0,
        }}
      >
        <FlexGrow
          className="visible-scrollbar"
          style={{
            overflowX: "auto",
            maxHeight: "calc(100vh - 70px)",
            minHeight: "calc(100vh - 70px)",
          }}
        >
          <CustomFlex>
            <FlexGrow>
              <PillarNavigator path={pillarNavigation} />
            </FlexGrow>
          </CustomFlex>
          <TableComponent navHeight="170px" aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => {
                  if (column.id === "action") {
                    return (
                      <StyledHeaderCell
                        key={column.id}
                        align={column.align}
                        backgroundColor={theme.color.lightBlueGray50}
                        color={theme.color.lightBlueGray800}
                        style={{
                          minWidth: 300,
                          // maxWidth: "195px",
                          textAlign: "end",
                        }}
                      >
                        <SaveButton
                          className="reduce_opct_onhover"
                          onClick={() => setIsCreateOpen(true)}
                          style={{
                            width: "auto",
                            color: "white",
                          }}
                        >
                          <Icon fontSize="small" style={{ paddingRight: 5 }}>
                            add_circle_outline_icon
                          </Icon>
                          Create Knowledge Topic
                        </SaveButton>
                      </StyledHeaderCell>
                    );
                  }
                  return (
                    <StyledHeaderCell
                      key={column.id}
                      align={column.align}
                      backgroundColor={theme.color.lightBlueGray50}
                      color={theme.color.lightBlueGray800}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </StyledHeaderCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {knowledgeTopic?.map((row: any, index) => {
                return (
                  <StyledTableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    onDoubleClick={() =>
                      navigate(
                        `/modify/pillar/${pillarNavigation.id}/subdomain/${pillarNavigation.subdomains.id}/knowledge-area/${pillarNavigation.subdomains.knowledge_areas.id}/knowledge-topic/${row.id}`
                      )
                    }
                    // onClick={() => {
                    //   onSelect(row);
                    // }}
                    key={index}
                  >
                    {columns.map((column) => {
                      if (column.id === "action") {
                        return (
                          <StyledBodyCell
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                            style={{
                              verticalAlign: "middle",
                              textAlign: "end",
                              paddingRight: "30px",
                            }}
                            key={column.id}
                            align={column.align}
                          >
                            <FlexBox>
                              <FlexGrow
                                className="reduce_opct_onhover"
                                style={{ marginRight: "16px" }}
                              >
                                <ClickableIcon
                                  style={{
                                    textShadow: "0 2px 4px #8080807a",
                                  }}
                                  onClick={() =>
                                    navigate(
                                      `/modify/pillar/${pillarNavigation.id}/subdomain/${pillarNavigation.subdomains.id}/knowledge-area/${pillarNavigation.subdomains.knowledge_areas.id}/knowledge-topic/${row.id}`
                                    )
                                  }
                                  fixedWidth={false}
                                  size={3}
                                  name={"edit"}
                                />
                              </FlexGrow>
                              <FlexGrow
                                className="reduce_opct_onhover"
                                style={{ flexGrow: 0 }}
                              >
                                <ClickableIcon
                                  onClick={() => {
                                    setCurrentPillar(row);
                                    setIsConfirmOpen(true);
                                  }}
                                  style={{
                                    color: "red",
                                    textShadow: "0 2px 4px #8080807a",
                                  }}
                                  fixedWidth={false}
                                  size={3}
                                  name={"delete"}
                                />
                              </FlexGrow>
                            </FlexBox>
                          </StyledBodyCell>
                        );
                      }
                      const value = row[column.id];
                      return (
                        <StyledBodyCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </StyledBodyCell>
                      );
                    })}
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </TableComponent>
        </FlexGrow>
      </CustomFlex>
    </>
  );
}
export default SubdomainKnowledgeTopics;
